import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import styles from './VpPaymentInfo.module.less';

export const BILLING_KEY = 'Billing Method';
export const PRICING_KEY = 'Pricing Details';
export const DATE_KEY = 'Next Billing Date';

const parsePaymentInfo = (paymentInfo, isAppSumo, codeCount) => {
  if (isAppSumo) {
    return [
      {
        key: BILLING_KEY,
        value: 'AppSumo',
        action: ''
      },
      {
        key: PRICING_KEY,
        value: codeCount > 1 || codeCount === 0 ? `${codeCount} Codes` : `${codeCount} Code`
      },
      { key: DATE_KEY, value: '' }
    ];
  }
  if (!paymentInfo) {
    return [
      {
        key: BILLING_KEY,
        value: ' N/A '
      },
      { key: PRICING_KEY, value: 'Free Trial' },
      { key: DATE_KEY, value: '-' }
    ];
  }

  const { brand, expiration, last4, nextBillingDate, planName } = paymentInfo;
  const hasCard = !!brand && !!last4 && !!expiration;
  return [
    {
      key: BILLING_KEY,
      value: hasCard ? `${brand} ending in ${last4}, Exp ${expiration}` : 'N/A',
      ...(hasCard ? { action: 'Update' } : {})
    },
    { key: PRICING_KEY, value: planName || 'Free Trial' },
    { key: DATE_KEY, value: nextBillingDate || '-' }
  ];
};

export const VpPaymentInfo = ({
  paymentInformation = null,
  openPaymentModalHandler,
  isAppSumo,
  codeCount
}) => {
  const parsedPaymentInfo = parsePaymentInfo(paymentInformation, isAppSumo, codeCount);
  return (
    <Box className={styles.vpPaymentInfoWrapper}>
      <Typography variant="h3" className={styles.vpPaymentInfoHeader}>
        Payment Information
      </Typography>
      {parsedPaymentInfo.map((info) => {
        return (
          <Typography key={info.key} variant="div" className={styles.vpPaymentInfoItem}>
            <Typography data-testid={`payment-info-key-${info?.key}`} variant="span">
              {info.key}
            </Typography>
            <Typography data-testid={`payment-info-value-${info?.key}`} variant="span">
              {info.value}
            </Typography>
            {info.action && (
              <Typography
                data-testid={`payment-info-action-${info?.key}`}
                className={styles.vpPaymentInfoUpdateAction}
                variant="span"
                onClick={openPaymentModalHandler}
              >
                {info.action}
              </Typography>
            )}
          </Typography>
        );
      })}
    </Box>
  );
};

VpPaymentInfo.propTypes = {
  paymentInformation: PropTypes.shape({
    brand: PropTypes.string,
    expiration: PropTypes.string,
    last4: PropTypes.string,
    nextBillingDate: PropTypes.string,
    paymentInfo: PropTypes.string
  }),
  openPaymentModalHandler: PropTypes.func,
  isAppSumo: PropTypes.bool,
  codeCount: PropTypes.number
};

VpPaymentInfo.displayName = 'VpPaymentInfo';

export default VpPaymentInfo;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPaymentInfo.jsx